import moment from "moment";

export function extractTime(timestamp) {
    const dateObj = new Date(timestamp);
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const time = `${hours}:${minutes}`;
    return time;
  }

export function convertUtcToIst (utcTimestamp) {
    const istTimestamp = moment
      .utc(utcTimestamp)
      .utcOffset("+05:30")
      .format("YYYY-MM-DD HH:mm:ss");
    return istTimestamp;
  }

  const parseTime = (timeString) => {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  };

  export function TimeDifferenceCalculator({ time1, time2 }) {
    const minutes1 = parseTime(time1);
    const minutes2 = parseTime(time2);
    const timeDifferenceInMinutes = minutes2 - minutes1;
    const hours = Math.floor(timeDifferenceInMinutes / 60);
    const remainingMinutes = timeDifferenceInMinutes % 60;
    return `${hours}h ${remainingMinutes}min`;
    
  }